import React from 'react'
import PropTypes from 'prop-types'

const HotelTags = ({ tags }) => {
  return (
    <div className="tags">
      {tags.sort((n1, n2) =>
        n1.sorting_order - n2.sorting_order
        ).map((tag, i) => {
          return <span key={i}>{tag.name}</span>
        })
      }
    </div>
  )
}

HotelTags.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    sorting_order: PropTypes.number.isRequired
  })).isRequired,
}

export default HotelTags
